export const EsLocale = {
    page: {
        txtTitle: 'SHIRITORI | Aprende vocabulario japonés online con el divertido juego しらとり',
    },
    common: {
        txtLogoAlt: 'Tren de Shiritori',
    },
    header: {
        txtLeave: 'SALIR DE LA PARTIDA',
    },
    dialog: {
        leave: {
            txtTitle: '¿Salir de esta partida?',
            btnStay: 'SEGUIR EN LA PARTIDA',
            btnLeave: 'SALIR Y RENDIRSE',
        },
    },
    home: {
        btnNewGame: 'NUEVA PARTIDA',
        btnMainMenu: 'MENÚ PRINCIPAL',
        btnJoinGame: 'UNIRSE',
        btnReturnToGame: 'VOLVER A LA PARTIDA',
    },
    create: {
        headingNamePrompt: '¿Cómo te llamamos?',
        placeholderName: 'Tu nombre',
        btnOk: 'OK',
    },
    join: {
        placeholderName: 'Tu nombre',
        placeholderGameId: 'id de partida',
        btnJoinGame: 'UNIRSE',
    },
    configure: {
        header: 'CONFIGURACIÓN DE PARTIDA',
        labelExpectedPlayers: 'Número de jugadores',
        labelBoardSize: 'Tamaño del tablero',
        labelWordList: 'Lista de palabras',
        labelAllowHints: 'Permitir pistas',
        labelTurnTimer: 'Temporizador de turno',
        optionNoTimer: 'Sin temporizador',
        optionTimer: 'Temporizador',
        unitSeconds: 's',
        btnStartGame: 'EMPEZAR',
        toastCreateError: 'Error: no se puede crear esta partida',
        toastTryAgain: 'Error: inténtalo de nuevo más tarde.',
    },
    game: {
        lobby: {
            btnReady: 'Listo',
            txtShareInvite: '¡Comparte este código con tus amigos!',
            txtPlayer: 'Jugador',
            txtTeam: 'Equipo',
        },
        message: {
            noSuchGame: 'Esta partida no existe',
            txtLoading: 'Cargando...',
            txtCannotJoin: 'No se puede unir a la partida',
        },
        gameplay: {
            board: {
                timeoutTitle: 'TIEMPO',
                timeoutSubtitle: 'agotado',
            },
            wordSearch: {
                multipleMatches: '¡SE ENCONTRARON VARIAS COINCIDENCIAS!',
                yourTurn: 'TU TURNO',
                placeholder: '¿Qué palabra jugamos?',
                playAction: 'JUGAR',
                timerSeconds: '{{seconds}}s',
                toastNoSuchWord: '¡Esa palabra no existe!',
                toastCantPlay: '¡No puedes jugar esa palabra!',
                toastPlayed: 'Jugaste "{{word}}"',
                toastPlayFailed: '¡Ups, no se pudo jugar esa palabra!',
                validation: {
                    syllableMismatch: 'La sílaba inicial no coincide',
                    missingLastWord: 'El turno anterior no tiene palabra',
                    wordNotInList: 'La palabra no pertenece a la lista',
                }
            },
            spectate: {
                waitingOn: 'Esperando a {{player}}',
                timeLeft: 'Tiempo restante: {{seconds}}s',
            },
            endGame: {
                header: 'PARTIDA TERMINADA',
                viewResults: 'VER RESULTADOS',
                statsTotalTime: 'Tiempo total de partida',
                statsSquaresFilled: 'Casillas llenas',
                statsLongestWord: 'Palabra más larga',
                share: 'Compartir',
                sharing: 'Compartiendo...',
                ariaCloseLabel: 'Cerrar modal de fin de partida',
            }
        },
    },
    footer: {
        linkHowToPlay: 'Cómo jugar',
        linkPrivacyPolicy: 'Política de privacidad',
        txtAllRightsReserved: 'Todos los derechos reservados.',
    },
    howToPlay: {
        title: 'Cómo jugar Shiritori しりとり (shiritori)',
        btnPlayNow: '¡Jugar ahora!',
        btnReturnToGame: 'Volver a la partida:',
        description1: 'b|Shiritori| es nuestra versión online y multijugador del juego japonés de encadenar palabras しりとり. Construye un tablero de imágenes mientras practicas vocabulario con amigos o en solitario.',
        description2: 'Crea o únete a una partida, elige tamaño del tablero, set de imágenes y lista de palabras, y corre por llenar la cuadrícula con palabras válidas antes de que alguien falle.',
        gameSetup: {
            title: 'Crear o unirse a una partida',
            p1: 'Empieza en solitario o invita hasta 9 amigos (10 jugadores en total) con un enlace compartible o código de partida.',
            p2: 'Elige las opciones que quieras: tamaño del tablero (3x3, 5x5, 7x7), patrón/color de fondo, set de imágenes y lista de palabras para estudiar.',
            p3: 'Tus amigos abren el enlace, eligen un apodo y aparecen en la sala; la partida empieza cuando se unan los jugadores esperados.',
            p4: 'Quienes lleguen tarde aún pueden ver una partida en curso en modo solo lectura.',
        },
        objective: {
            title: 'Objetivo',
            p1: 'Encadena palabras para que cada palabra nueva empiece con la última sílaba de la anterior, llena el tablero y nunca termines una palabra con ん.',
        },
        wordRules: {
            title: 'Palabras válidas',
            p1: 'Escribe en kana o romaji; el romaji se convierte a hiragana del lado del cliente antes de comprobar.',
            p2: 'Las palabras deben existir en la lista seleccionada (100/1000 comunes, comida, deportes, etc.) y muestran su significado después de jugarlas.',
            p3: 'Las palabras usadas se bloquean. Si se permiten homófonos, puedes elegir una variación sin usar con la imagen correcta.',
            li1: 'Empieza con la sílaba requerida del turno anterior',
            li2: 'No termina en ん (n)',
            li3: 'Está incluida en la lista elegida',
            li4: 'No se jugó antes en esta partida',
            li5: 'Usa un homófono/imagen permitido cuando esa regla está activada',
            p4: 'Cada jugada válida coloca su imagen en orden en el tablero, llenándolo de izquierda a derecha y de arriba a abajo. e|Ejemplo:_そば_→_バス|',
        },
        turnFlow: {
            title: 'Turnos y tiempo',
            p1: 'Los turnos rotan por la lista de jugadores; cuando te toca tienes hasta 10 segundos desde que ves tu turno.',
            p2: 'Shiritori espera a que el siguiente jugador esté activo (navegador enfocado) antes de iniciar su cuenta atrás, evitando saltarse el temporizador al reiniciar o recargar.',
            p3: 'Escribe tu palabra, mira la validación en vivo y envía antes del límite: los envíos inválidos o tarde terminan la partida de inmediato.',
        },
        boardFlow: {
            title: 'Tablero, flujo y final',
            p1: 'El tablero muestra cada palabra jugada con su imagen, nombre del jugador y número de turno, con flechas que trazan el orden en la cuadrícula.',
            p2: 'Cuando es el turno de otra persona, igual puedes ver la sílaba inicial requerida y la cuenta regresiva mientras esperas.',
            p3: 'Si se llenan todos los espacios con palabras válidas, la partida termina con éxito y muestra el tablero completo para compartir.',
            p4: 'Si no se envía una jugada válida antes de que se acabe el tiempo, la partida termina con un resumen de quién agotó el tiempo o jugó una palabra inválida.',
        },
        summary: {
            title: 'Resumen',
            p1: 'Shiritori mantiene shiritori rápido y visual: rondas cortas, reglas claras y mnemotecnia con imágenes ayudan a mantener viva la cadena.',
            p2: 'Comparte un enlace, llena el tablero y descubre cuánto puede durar tu cadena de palabras.',
        }
    },
    bugsAndFeatures: {
        title: 'Reportes de bugs y nuevas funciones',
        p1: 'Construimos este juego como una forma distinta de jugar al clásico k|しりとり.| Como equipo amante de los juegos, siempre buscamos maneras de mejorarlo y hacerlo más disfrutable.',
        cta: {
            l1: 'De hecho, nos encantaría que nos ayudaras ',
            a: 'compartiendo nuestro juego con tus amigos',
            l2: ' en redes sociales.'
        },
        p2: 'Si encuentras algún bug o tienes sugerencias de nuevas funciones, ¡cuéntanos!',
        bugs: {
            title: 'Bugs',
            p1: 'Por favor reporta cualquier comportamiento extraño, error o bug directamente en nuestro a|https://github.com/indexinteractive/|repositorio_público_de_GitHub| . Asegúrate de incluir la mayor cantidad de detalles posible, incluidos los pasos para reproducirlo.'
        },
        features: {
            title: 'Nuevas funciones',
            p1: 'Si tienes sugerencias de nuevas funciones, mejoras o ideas para el juego, háznoslo saber creando una discusión nueva en nuestra página de a|https://github.com/indexinteractive/|GitHub_Discussions| .'
        }
    },
    share: {
        title: 'Shiritori | Aprende vocabulario japonés online con el divertido juego しらとり - SHIRITORI',
        text: 'Juega Shiritori online con tus amigos o jugadores aleatorios. ¡No requiere registro!',
    }
};
